module.exports = __webpack_public_path__ + "img/1498514529.2392ae96.jpg";